import axios from 'axios';
import serviceHelper from '../../helpers/functions/service.helper';

async function generatePaymentLink(park_code, params = {}){
    try {
        const linkResponse = await axios.post(
            `payment/url/${park_code}`, 
            params, 
            { withCredentials : true }
        );
        return linkResponse?.data;
    } catch (error) {
        console.error('Payment Link Generation Error:', error);
        throw error;
    }
}

async function getPaymentStatus(){
    const paymentStatusResponse = await axios.get(`config/other/payment_status`, { withCredentials : true, });
    return paymentStatusResponse?.data;
}

export default {
    generatePaymentLink,
    getPaymentStatus,
}